import styled from 'styled-components';
import { BLACK, NEUTRAL_100, NEUTRAL_900, ORANGE } from '@styles/colors';
import { GIVONIC, INTER } from '@styles/fonts';
import AddressDisplay from '@components/AddressDisplay/AddressDisplay';
import { safeAreaInset } from '@lib/telegram';

export const Container = styled.div`
  color: ${BLACK};
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 12px 200px 12px;
  overflow-y: auto;
  flex: 1;
`;

export const AddressContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 18px;
`;

export const StyledAddressDisplay = styled(AddressDisplay).attrs({
  style: {
    fontFamily: INTER.semiBold,
    fontSize: '14px',
    color: BLACK,
    width: '70%',
  }
})``;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  padding: 0;
  margin: 0;
  align-items: center;
  justify-content: center;
`;

export const ResetWalletContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${NEUTRAL_100};
`;

export const ResetWalletText = styled.span`
  width: 100%;
  text-align: center;
  padding: 0;
  margin: 0;
  font-family: ${INTER.semiBold};
  font-size: 14px;
  color: ${ORANGE};
  cursor: pointer;
`;

export const ResetWalletBottomSheetBodyContainer = styled.div`
  padding: 8px;
  padding-bottom: ${safeAreaInset().bottom || 8}px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  height: 100%;
`;

export const ResetWalletWarningText = styled.span`
  font-family: ${GIVONIC.regular};
  font-size: 14px;
  color: ${NEUTRAL_900};
`;
